import { render, staticRenderFns } from "./modifiedData.vue?vue&type=template&id=6586d686&scoped=true"
import script from "./modifiedData.vue?vue&type=script&lang=js"
export * from "./modifiedData.vue?vue&type=script&lang=js"
import style0 from "./modifiedData.vue?vue&type=style&index=0&id=6586d686&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6586d686",
  null
  
)

export default component.exports